import { render, staticRenderFns } from "./DaysOfWeekSettingForm.vue?vue&type=template&id=e2c2dce2&scoped=true&"
import script from "./DaysOfWeekSettingForm.vue?vue&type=script&lang=js&"
export * from "./DaysOfWeekSettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c2dce2",
  null
  
)

export default component.exports